import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import ro from './ro.json';
import es from './es.json';

// IMPORTANT:
// Only use two letter ISO codes here!

export const translations = {
  de,
  en,
  fr,
  ro,
  es,
};